//
import { mapActions } from 'vuex'
import { ModelDataTable } from '@/components/reusable_components/next'

//
import ProviderToListModel from '@/models/Purchase/PchProviderToList'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'provider-list',
    components: {
        'crud-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                service: ProviderToListModel,
                filters,
                headers,
            }
        },
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'provider-update',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Proveedores')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_PROVIDER')) ctx.$router.push('/')
        })
    },
}
